module.exports = __webpack_public_path__ + "static/tatianawork5-65083feb869a8df1216428f93c51d645.jpeg";